// Support resources catalog — Employee Portal & App spec §15; User Journeys &
// Service Design v2, Journey 02 (the "Wellbeing Resources" screen).
//
// Browse-only view of approved support resources (§15.2 fields), rendered as a
// calm card grid inside the employee portal (inherits `data-surface="employee"`
// blue palette). Never a long document dump. Copy stays neutral per §1.4 #8.
//
// No access is recorded from this view — the catalog is deliberately not
// instrumented (§19.2: resource-usage analytics reads as surveillance). The
// crisis-link recorder elsewhere is scoped to the red-flag handoff, not here.
//
// Card grid + query itself lives in `ResourceCatalogGrid.tsx`, shared with the
// Manager view (`ManagerResources.tsx`) — this owns only the Employee-specific
// header copy and the closing reassurance note.

import { ResourceCatalogGrid } from '@/components/ResourceCatalogGrid.tsx';
import { HeartIcon } from '@/components/ui/icons.tsx';

export function EmployeeResourcesCard() {
  return (
    <section className="space-y-5">
      <header>
        <h2 className="text-lg font-semibold">Wellbeing resources</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Everything available to you — at no cost, at any time. Use any of these whenever you feel
          ready.
        </p>
      </header>

      <ResourceCatalogGrid
        endpoint="/api/employee/resources"
        queryKey={['employee', 'resources']}
        footer={<CalmFooter />}
      />
    </section>
  );
}

// Journey 02 — the calm closing note. No pressure, no chase.
function CalmFooter() {
  return (
    <div className="flex items-start gap-3 rounded-lg bg-primary-soft/50 p-4">
      <span aria-hidden className="mt-0.5 shrink-0 text-primary [&_svg]:size-5">
        <HeartIcon />
      </span>
      <p className="text-sm text-muted-foreground">
        <span className="font-medium text-foreground">It&rsquo;s okay to take your time.</span> Come
        back whenever you need to — there&rsquo;s no right time to use support, only what feels
        right for you.
      </p>
    </div>
  );
}
